import { getArchiveKind } from '../utils/archiveKinds'

import { Document } from '@/features/library/types/document'
import { cn } from '@/shared/lib/utils'
import { AdminAutoCompleteButton } from '@/shared/ui/AdminAutoCompleteButton'
import { CardRewards, CardTile, CardTileImage } from '@/shared/ui/Card'

interface DocumentCardProps {
  document: Document
  onClick: () => void
}

export const DocumentCard = ({ document, onClick }: DocumentCardProps) => {
  return (
    <CardTile
      className="bg-linear-to-t from-[#E4E8FA] to-[#DDD4FF] cursor-pointer hover:shadow-[0_2px_0_0_#C7BFFF] transition-all duration-100"
      onClick={onClick}
    >
      <CardTileImage src={document?.thumb?.file?.url} />
      <div className="flex flex-col gap-1 items-start">
        <span className="text-md font-medium text-primary-dark block">
          {document.name}
        </span>
        <div className="flex gap-2 flex-wrap">
          {document?.document_category && (
            <span className="text-xs font-normal rounded-sm px-1  text-white block bg-jacaranda">
              {document.document_category.name}
            </span>
          )}
          {!!getArchiveKind(document.archive_kind) && (
            <span
              className={cn(
                'text-xs font-normal rounded-sm px-1 text-white block',
                {
                  'bg-jacaranda': document.archive_kind === 'link',
                  'bg-begonia': document.archive_kind === 'archive',
                  'bg-canario': document.archive_kind === 'image',
                  'bg-manaca': document.archive_kind === 'embedded',
                  'bg-tie': document.archive_kind === 'video_url',
                  'bg-guaco': document.archive_kind === 'text'
                }
              )}
            >
              {getArchiveKind(document.archive_kind)?.name}
            </span>
          )}
        </div>
        <span className="text-sm font-medium text-[#434368] max-w-[400px] line-clamp-2 block">
          {document.description}
        </span>
      </div>
      <CardRewards
        coinReward={document.coin_reward}
        pointReward={document.point_reward}
        completed={document._progress.finished}
        claimed={document._progress.claimed}
        withClaimedBadge
        className="ml-auto shrink-0"
      />
      <AdminAutoCompleteButton type="Document" id={document.id} />
    </CardTile>
  )
}
